import { Component, OnInit, Inject } from '@angular/core';
import {environment} from '../../environments/environment';

import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Observable } from 'rxjs/Rx';

import { HttpService } from '../services/HttpService';
import { NotificationService } from '../services/NotificationService';
import { FileUploadService } from '../services/FileUploadService';



@Component({
	selector: 'app-edit-brand',
	templateUrl: './edit-brand.component.html',
	styleUrls: ['./edit-brand.component.scss'],
	providers: [HttpService, NotificationService, FileUploadService]
})
export class EditBrandComponent implements OnInit {

	public apiUrl = environment.apiUrl;

	public loading: boolean = false;
	public User_Details: any;


	public brandDetails = {
		id: "",
		name: "",
		email: "",
		phone: "",
		image_path: "",
		facebook_connected: 0
	}

	constructor(
		public dialogRef: MatDialogRef<EditBrandComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any,
		public http: HttpService,
		public notification: NotificationService,
		public fileUpload: FileUploadService
	) { }

	fileChange(event) {
		const selected = event.target.files && event.target.files[0];
		if (!this.fileUpload.isValidImageFile(selected)) {
			this.notification.showNotification('Please select an image file (JPG or PNG).', 'Invalid file', 'error');
			event.target.value = '';
			return;
		}
		this.loading = true;
		this.fileUpload.uploadFile("admin/user/brands/image/insert", event.target.files)
			.subscribe(
				(response) => {
					this.loading = false;
					console.log(response);
					if (response.data) {
						this.brandDetails.image_path = response.data;
					}
					else {
						this.notification.showNotification("Could not upload the image", "Error", "error");
					}
				},
				(error) => {
					this.loading = false;
					console.log(error);
					this.notification.showNotification("Could not upload the image", "Error", "error");
				}
			)
		//
	}

	ngOnInit() {
        console.trace()
		this.User_Details = JSON.parse(localStorage.getItem("Admin_User_Details"));
		this.brandDetails = this.data.brandDetails;
	}

	updateBrand() {
		this.loading = true;
		this.http.makeRequestPost(["admin/user/brands/edit", {
			id: this.brandDetails.id,
			token: this.User_Details.token,
			name: this.brandDetails.name,
			email: this.brandDetails.email,
			phone: this.brandDetails.phone || "",
			image_path: this.brandDetails.image_path,
		}])
			.subscribe(
				(response) => {
					this.loading = false;
					if (response.data) {
						this.brandDetails = response.data;
						this.dialogRef.close({ changeBrand: this.brandDetails });
					}
					if (response.error) {
						this.notification.showNotification("Could not edit the brand details", "Error", "error");
					}
				},
				(error) => {
					this.loading = false;
					this.notification.showNotification("Please make sure you have a working data connection", "Error", "error");
				}
			)
	}

}



// WEBPACK FOOTER //
// ./src/app/edit-brand/edit-brand.component.ts